import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BadgeColor, BadgeComponent } from '../../shared/components/ui/badge/badge.component';
import { AdminBookingsService } from '../../core/services/admin-bookings.service';
import { AdminMechanicsService } from '../../core/services/admin-mechanics.service';
import { AdminBooking, AdminMechanic } from '../../core/models/admin.models';

@Component({
  selector: 'app-bookings-details',
  standalone: true,
  imports: [CommonModule, FormsModule, BadgeComponent],
  templateUrl: './bookings-details.component.html',
  styleUrls: ['./bookings-details.component.css']
})
export class BookingsDetailsComponent implements OnInit {

  bookingId!: number;
  booking: AdminBooking | null = null;
  mechanics: AdminMechanic[] = [];
  selectedMechanicId: number | null = null;

  isLoading = false;
  isAssigning = false;
  errorMessage = '';

  constructor(
    private route: ActivatedRoute,
    private bookingsService: AdminBookingsService,
    private mechanicsService: AdminMechanicsService
  ) {}

  ngOnInit() {
    const idParam = this.route.snapshot.paramMap.get('id');
    if (idParam) {
      this.bookingId = Number(idParam);
      this.loadBooking();
      this.loadMechanics();
    } else {
      this.errorMessage = 'No booking ID provided.';
    }
  }

  loadBooking() {
    this.isLoading = true;
    this.errorMessage = '';
    
    this.bookingsService.getBooking(this.bookingId).subscribe({
      next: (data) => {
        this.booking = data;
        this.isLoading = false;
      },
      error: (err) => {
        this.errorMessage = err?.error?.message ?? 'Failed to load booking details.';
        this.isLoading = false;
      }
    });
  }

  loadMechanics() {
    this.mechanicsService.getMechanics().subscribe(res => {
      this.mechanics = Array.isArray(res) ? res : (res as any).data ?? [];
    });
  }

  assignMechanic() {
    if (!this.selectedMechanicId) return;
    this.isAssigning = true;
    this.bookingsService.assignMechanic(this.bookingId, this.selectedMechanicId).subscribe({
      next: () => {
        this.isAssigning = false;
        alert('Mechanic assigned successfully.');
        this.loadBooking();
      },
      error: (err) => {
        this.isAssigning = false;
        alert(err?.error?.message ?? 'Failed to assign mechanic.');
      }
    });
  }

  getBadgeColor(status: string): BadgeColor {
    switch (status?.toLowerCase()) {
      case 'pending': return 'warning';
      case 'accepted': 
      case 'enroute': 
      case 'arrived': 
      case 'in_progress': return 'info';
      case 'completed': return 'success';
      case 'cancelled': return 'danger' as BadgeColor;
      default: return 'primary';
    }
  }
}